import { render, staticRenderFns } from "./btnTransferDeliveryToTable.vue?vue&type=template&id=aca2930e&"
import script from "./btnTransferDeliveryToTable.vue?vue&type=script&lang=js&"
export * from "./btnTransferDeliveryToTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports